import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_000.jpg';

page.gallery = [
  {
    id: 'u1',
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/karta1/1_hello.jpg',
        audio: {
          audioSrc: 'audio/karta1/1_hello.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/2_bye_bye.jpg',
        audio: {
          audioSrc: 'audio/karta1/2_bye_bye.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/3_Tom.jpg',
        audio: {
          audioSrc: 'audio/karta1/3_Tom.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/4_Lisa.jpg',
        audio: {
          audioSrc: 'audio/karta1/4_Lisa.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u2',
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/karta2/8_blue.jpg',
        audio: {
          audioSrc: 'audio/karta2/8_blue.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/9_red.jpg',
        audio: {
          audioSrc: 'audio/karta2/9_red.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/10_yellow.jpg',
        audio: {
          audioSrc: 'audio/karta2/10_yellow.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/11_green.jpg',
        audio: {
          audioSrc: 'audio/karta2/11_green.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
];
page.games = [
  {
    id: 'page000_game0',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game1',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game2',
    pos: { x: LEFT, y: 0 },
  },
];

export default page;
